//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { isUsingNewLayout } from '~/utils/isUsingNewLayout'
import getPage from '~/gql/getPage'
import head from '~/mixins/head'
export default {
  name: 'PageDepth1',
  mixins: [head],
  async asyncData({ $graphcms, route, app, error, store }) {
    const slug = route.params.slug ? route.params.slug : 'homepage'
    const isHomepage = slug === 'homepage'
    let navigationItems = []
    const navigationElements = ['Teaser', 'Carousel', 'ArticleTopic'] // todo: outsource

    const { pages, landingpages } = await $graphcms.request(getPage, {
      slug,
      lang: [app.i18n.locale],
      assetLocales: [app.i18n.locale, app.i18n.defaultLocale],
    })

    const page = pages?.[0] ? pages[0] : landingpages?.[0] ?? null
    const isLandingpage = pages?.length === 0 && landingpages?.length === 1

    // set page theme
    if (page && page.themeColor) {
      store.commit('global/setTheme', page.themeColor)
    }

    if (isLandingpage) {
      store.commit('global/setLayout', 'landingpage')
    } else {
      store.commit('global/setLayout', 'page')
    }

    if (!page) {
      return error({ statusCode: 404, message: 'noContent' })
    } else if (page?.showPageNavigation) {
      const pageLocales = {}
      page.localizations.forEach((localePage) => {
        pageLocales[localePage.locale] = { slug: localePage.slug }
      })

      await store.dispatch('i18n/setRouteParams', {
        ...pageLocales,
      })

      navigationItems = page.elements.filter((pageElements) => {
        return (
          (pageElements.showInLayout ===
            (isUsingNewLayout(app.i18n.locale) ? 'NEW' : 'OLD') ||
            pageElements.showInLayout === 'BOTH' ||
            !pageElements.showInLayout) &&
          pageElements.carouselType !== 'topics' &&
          navigationElements.some((el) => pageElements.type.includes(el))
        )
      })

      if (navigationItems.length > 0) {
        page.elements.splice(1, 0, {
          type: 'PageNavigation',
          items: navigationItems,
          title: 'PageNavigation',
        })
      }

      navigationItems = navigationItems.filter(
        (item) => item.carouselType !== 'mentorsStories'
      )
    }
    const elementsToShow = page.elements.filter(
      (pageElement) =>
        pageElement.showInLayout ===
          (isUsingNewLayout(app.i18n.locale) ? 'NEW' : 'OLD') ||
        pageElement.showInLayout === 'BOTH' ||
        !pageElement.showInLayout ||
        pageElement.type === 'PageNavigation'
    )

    page.elements = elementsToShow.map((element) => {
      if (element.variant === 'ArticleTopic' && element.link) {
        return {
          ...element,
          link: {
            ...element.link,
            url: `${element.link.parentPage?.slug ?? ''}/${element.link.url}`,
          },
        }
      }
      return element
    })

    // META
    const metaTitle = page
      ? page.seo?.metaTitle
        ? page.seo?.metaTitle
        : page.title
      : null

    const metaDescription = page
      ? page.seo?.metaDescription
        ? page.seo?.metaDescription
        : null
      : null

    const ogImage = page
      ? page.seo?.ogImage
        ? page.seo?.ogImage?.src
        : null
      : null

    return {
      page,
      isLandingpage,
      isHomepage,
      metaTitle,
      metaDescription,
      ogImage,
      navigationItems,
    }
  },
  computed: {
    isUsingNewLayout() {
      return isUsingNewLayout(this.$i18n.locale)
    },
  },
}
